import { AppThunk } from "@Store/index";
import { fetchBookFormPageDataIfNeeded } from "./bookFormReducer";

const loadData = (props: any): AppThunk[] => [
  fetchBookFormPageDataIfNeeded(props),
  // More pre-fetched actions...
];

export default loadData;
